module.exports = __webpack_public_path__ + "resources/reactions-db072cb2d285fba580ac7096fb654fe3.svg";